import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { LoginService } from '../../login/login.service';
import { UserSession } from '../../shared/user-session';
import { trigger, state, transition, style, animate, keyframes } from '@angular/animations';

@Component({
  selector: 'mem-okta-success',
  templateUrl: './new-login-widget-success.component.html',
  styleUrls: ['./new-login-widget-success.component.scss'],
  animations: [
    trigger('contratulations', [
      transition(':enter', animate('2s', keyframes([
        style({opacity: 0, transform: 'translateY(-75%)', offset: 0}),
        style({opacity: 1, transform: 'translateY(0)',     offset: 1.0})
      ])))
    ]),
    trigger('LoginInformation', [
     state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate("1s 3s")
      ]),
    ])
  ]
})
export class NewLoginWidgetSuccessComponent implements OnInit {

 

  loader: Boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loginSvc: LoginService,
    private userSession: UserSession,
  ) { }

  ngOnInit() {
    setTimeout(() => {
      // this.login();
      this.goToLogin();
    }, 14000);
  }

  goToLanding(){
    this.router.navigate(['/landing']);
  }

  goToLogin() {
    // new flow
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/new-login-widget/new-login-widget-success/new-login-widget-success.component.ts